<template>
  <artmisads-modal :open="open" :footer="false" :title="modalTitle" :width="860" :maskClosable="false"
    :onCancel="() => open = false" :destroyOnClose="true">
  <div class="table-head">
    <a-space>
      <ButtonGroups :pagination="pagination" :tableData="dataSource" @pageChange="onPageChange" />
    </a-space>
    <a-space>
      <a-input-search v-model:value="keywords" :placeholder="$t('seller.common.searchPlaceholder')" allow-clear @search="onSearch"
            @enter="onSearch">
      </a-input-search>
    </a-space>
  </div>
   
    <artmisads-table v-model:pagination="pagination" :columns="columns" :data-source="dataSource"
   
        :change="onTableChange" :loading="load" >
         <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'Product'">
            <div class="product-item" style="width: 300px;">
             
              <LogoImage :logoUrl="record.productImageUrl" :brandName="record.productTitle"/>
          <!-- <img :src='record.productImageUrl' /> -->
          <div class="text">
            <p class="title">{{record.productTitle}}</p>
            <div class="asin-vc-icon">
              <span class="asin">{{record.asin}}</span>
            </div>
          </div>
          </div>
          </template>
          <template v-else-if="column.key === 'publisher'">
             <div class="product-item">
          <LogoImage :logoUrl="record.avatarPath" :brandName="record.creatorName"/>
          <div class="text">
            <p class="title">{{record.creatorName}}</p>
          
          </div>
          </div>
          </template>
          <template v-if="column.key === 'productPrice'||column.key === 'sales'">
            <span>{{ CURRENCY_DATA_MAPPER[record.currencyCode] }} {{record[column.key]}}</span>
          </template>
          <template v-else-if="column.key === 'content'">
            <span>{{ returnContent(record) }}</span>
          </template>
          <template v-else-if="column.key === 'artemisAdsStatus'">
            <artmisads-button type="primary" size="small" v-if="record.artemisAdsStatus">
              {{ $t('seller.sellerAccount.claimed') }}
            </artmisads-button>
            <artmisads-button type="primary" :disabled="true" size="small" v-else>
              {{ $t('seller.sellerAccount.unclaimed') }}
            </artmisads-button>
          </template>
        </template>
      </artmisads-table>
  </artmisads-modal>
</template>
<script setup lang="jsx">
import { ref, defineExpose, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { sellerAccountApi } from '~/server'
import { message } from 'ant-design-vue'
import { CURRENCY_DATA_MAPPER } from '@/contants/common'
import ButtonGroups from '../../Brands/components/buttonGroups.vue';
import LogoImage from '@/components/LogoImage.vue'

const { t } = useI18n()
const campaignId = ref('')
const keywords = ref('')
const open = ref(false)
const viewType = ref('products')

const modalTitle = computed(() =>
  viewType.value === 'products'
    ? t('seller.sellerAccount.modalCampaignProducts')
    : t('seller.sellerAccount.modalCampaignPublishers')
)

const columns = computed(() => {
  if (viewType.value === 'products') {
    return [
      {
        title: t('seller.sellerAccount.colProduct'),
        dataIndex: 'Product',
        key: 'Product',
        width: '150px',
      },
      {
        title: t('seller.sellerAccount.colPrice'),
        dataIndex: 'productPrice',
        key: 'productPrice',
      },
      {
        title: t('seller.sellerAccount.colStatus'),
        dataIndex: 'status',
        key: 'status',
      },
      {
        title: t('seller.sellerAccount.colAvailability'),
        dataIndex: 'availability',
        key: 'availability',
      },
    ]
  }
  return [
    {
      title: t('seller.menu.publisher'),
      dataIndex: 'publisher',
      key: 'publisher',
      width: '150px',
    },
    {
      title: t('seller.sellerAccount.colContent'),
      dataIndex: 'content',
      key: 'content',
    },
    {
      title: t('seller.sellerAccount.colSales'),
      dataIndex: 'sales',
      key: 'sales',
    },
    {
      title: t('seller.sellerAccount.colArtemisAdsStatus'),
      dataIndex: 'artemisAdsStatus',
      key: 'artemisAdsStatus',
    },
  ]
})

const pagination = ref({
  total: 30,
  defaultPageSize: 10,
  size: 10,
  current: 1,
  showSizeChanger: true,
  pageSize: 10,
  pageSizeOptions: ['10', '20', '30', '40', '50']
})
const dataSource = ref([])
const load = ref(false)
const onTableChange = ({ current, pageSize }) => {
  pagination.value.current = current
  pagination.value.size = pageSize
  pagination.value.pageSize = pageSize
  if (viewType.value === 'products') {
    getProductsList()
  } else {
    getCampaignPublishersList()
  }
}
const onPageChange = (current) => {
  pagination.value.current = current
  if (viewType.value === 'products') {
    getProductsList()
  } else {
    getCampaignPublishersList()
  }
}
const openModal = (type,id) => {
  open.value = true
  
  campaignId.value = id
  pagination.value = {
  total: 30,
  defaultPageSize: 10,
  size: 10,
  current: 1,
  showSizeChanger: true,
  pageSize: 10,
  pageSizeOptions: ['10', '20', '30', '40', '50']
}
  keywords.value = ''
  viewType.value = type === 'products' ? 'products' : 'publishers'

  if (type === 'products') {
    getProductsList()
  } else {
    getCampaignPublishersList()
  }
}
const onSearch=()=>{
  pagination.value.current = 1;
  if (viewType.value === 'products') {
    getProductsList()
  } else {
    getCampaignPublishersList()
  }
}
const getProductsList = async () => {
  load.value = true
  const res = await sellerAccountApi.getCampaignProductsList({
    page: pagination.value.current,
    size: pagination.value.size,
    keyword: keywords.value,
    campaignId: campaignId.value,
  })
  const { data, success, error } = res
  if (success) {
   
    dataSource.value = data.data
    pagination.value.total = data.total
  }else{
    message.error(error)
  }
  load.value = false
}
const getCampaignPublishersList = async () => {
  load.value = true
  const res = await sellerAccountApi.getCampaignPublishersList({
    page: pagination.value.current,
    size: pagination.value.size,
    keyword: keywords.value,
    campaignId: campaignId.value,
  })
  const { data, success, error } = res
  if (success) {
    dataSource.value = data.data
    pagination.value.total = data.total
  }else{
    message.error(error)
  }
  load.value = false
}
const returnContent = (record) => {
  if(record?.content?.length > 0){
    return record.content.join(',')
  }
  return t('seller.sellerAccount.noContentSubmitted')
}
defineExpose({
openModal
})
</script>
<style scoped lang="less">
.table-head {
  display: flex;
  height: 64px;
  justify-content: space-between;
  align-items: center;
  }
 .product-item {
    display: flex;
    // width: 300px;
    max-width: 200px;
    gap: 6px;
    .asin-vc-icon{
      display: flex;
      align-items: center;
      // justify-content: flex-end;
      gap: 4px;
    }
    img {
      width: 56px;
      height: 56px;
      margin-right: 12px;
      // border: 1px solid var( --border-1);
      border-radius: 8px;
      object-fit: contain;
    }

    .text {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      justify-content: center;

      .title {
        max-width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: var(--dark-1);
        font-weight: 500;
        font-size: var(--font-size-middle);
        text-decoration: underline;
      }

      .asin {
        color: var(--dark-3);
        font-weight: 500;
        font-size: var(--font-size-min);
        letter-spacing: 0.3px;
        text-align: right;
        line-height: 16px;
        text-align: left;
        margin-top: 2px;
      }
    }
  }
  
</style>
